import { CoordinatorProfileResponse } from "../../api/user/model";
import { GET_COORDINATOR_PROFILE_URL } from "../../constants/apiUrls"
import { GET_COORDINATOR_PROFILE_QUERY_KEY } from "../../constants/queryKeys";
import axiosClient from "../axiosClient"
import { useCustomQuery } from "../utils/useCustomQuery";

export const useGetCoordinatorProfile = () => {
  const getCoordinatorProfile = async () => {
    const res = await axiosClient.get<CoordinatorProfileResponse>(GET_COORDINATOR_PROFILE_URL);

    return res.data;
  }

  return useCustomQuery(GET_COORDINATOR_PROFILE_QUERY_KEY, getCoordinatorProfile);
}
